import { useQuery } from "@tanstack/react-query";
import { format } from "date-fns";

import proxy from "api/proxy";
import NoInfo from "./NoInfo";

function Issues({ sections = [] }) {
  const sectionIds = sections.map((s) => s.id);

  async function searchSection(sectionId) {
    const { data } = await proxy.methodCall({
      model: "staff.shift",
      method: "find_shift_issues",
      args: [{ section_id: sectionId }],
    });
    return data || [];
  }

  async function searchData() {
    if (!sectionIds.length) {
      return null;
    }
    const results = await Promise.all(sectionIds.map(searchSection));
    const issues = results.flat();
    return issues.length ? issues : null;
  }

  const { data } = useQuery({
    queryKey: ["searchIssues", ...sectionIds],
    queryFn: searchData,
  });

  return (
    <div className="mx-2 w-full bg-neutral-100 rounded-2xl">
      <h1 className="text-3xl text-center text-neutral-500 my-6 font-bold">
        Anomalias
      </h1>
      <div className="grid py-2 px-4 rounded-2xl gap-y-2">
        {data ? (
          data.map((shift) => (
            <div className="p-3 bg-rose-100 rounded-2xl" key={shift.id}>
              <div className="text-sm text-rose-900">{shift.employee_name}</div>
              <div className="text-sm text-neutral-700">
                {shift.section_name}
              </div>
              <div className="flex justify-between">
                <div className="text-sm">
                  <span className="text-neutral-700 font-bold">
                    {shift.shift_date}
                  </span>
                </div>
                <div className="text-sm text-rose-900">
                  <span className="text-neutral-600">Turno: </span>
                  <span className="text-rose-800 font-bold">{shift.kind}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <NoInfo color="bg-neutral-100" />
        )}
      </div>
    </div>
  );
}

export default Issues;
